export const shouldRunReranker = ({
  routerContract = null,
  sufficiency = null,
  retrievalMeta = null,
  confidenceThreshold = 0.72,
  topDocShareThreshold = 0.65
} = {}) => {
  const contract = routerContract && typeof routerContract === 'object' ? routerContract : null;
  const overallConfidence = Number(contract?.confidence?.overall || 0);
  if (Boolean(contract?.needs_reranker)) {
    return {
      run: true,
      reasonCodes: ['router_requested_reranker']
    };
  }

  const reasons = [];
  if (overallConfidence > 0 && overallConfidence < Number(confidenceThreshold || 0.72)) {
    reasons.push('router_low_confidence');
  }

  const sufficiencyDecision = String(sufficiency?.decisionCode || '').trim().toLowerCase();
  if (sufficiencyDecision === 'insufficient') {
    reasons.push('sufficiency_insufficient');
  }

  const topDocBreakdown = Array.isArray(retrievalMeta?.selectedDocBreakdown)
    ? retrievalMeta.selectedDocBreakdown
    : [];
  const totalSelected = Number(retrievalMeta?.selectedCount || 0);
  const topDocCount = Number(topDocBreakdown?.[0]?.count || 0);
  const topDocShare = totalSelected > 0 ? (topDocCount / totalSelected) : 0;
  if (topDocShare > Number(topDocShareThreshold || 0.65)) {
    reasons.push('top_doc_concentration_high');
  }

  return {
    run: reasons.length > 0,
    reasonCodes: reasons
  };
};
